import { WhitelabelCodeReturnDecide } from "@/utils/utils";
import { useWhiteLabelCode } from "@/v2/stores";

const getWhiteLabelDisplayName = (code: string | null): string => {
  if (!code) return "Lisa";
  const mapping: Record<string, string> = {
    sharebike: "Lisa",
    lisa: "LISA",
    bigIssue: "Bigissue",
    esb: "ESB",
    farteBysykkel: "Farte",
    sigo: "Sigo",
    sefa: "Sefa",
    weelz: "Weelz",
    gjovik: "Gjøvik",
  };
  return mapping[code] || "Lisa";
};

const generateFineText = (brandName: string) => `Dear ${brandName} Customer,

During a recent review, we noticed that your bike was parked in violation of our parking guidelines. To help clarify the situation, we've attached the image submitted at the end of your rental for your reference.

As per our parking policy, a fine has been applied to your account.

Why is this important?
Incorrectly parked bikes can disrupt public spaces and violate our agreements with local authorities. We understand this can be frustrating, so we provide parking guidance at the end of each rental to help you avoid any issues.

Where to Park Correctly:
You can avoid fines by parking only at any public bike parking rack, located on public property within our operating zone, which is indicated in the app.
When bikes are parked incorrectly, our team may need to remove and re-park them, especially if public complaints arise or the bike remains unmoved for a certain period.

If You Believe This Was a Mistake:
If you feel this fine was issued in error, simply reply to this message, and we'll be happy to review the situation and address any concerns.

Thank you for your understanding and cooperation.

Best regards,
The ${brandName} Team
`;

const generateWarningText = (brandName: string) => `Dear ${brandName} Customer,

During a recent review, we noticed that your bike was parked in violation of our parking guidelines. To help clarify the situation, we've attached the image submitted at the end of your rental for your reference.

This is a warning notice to remind you of our parking policy. No fine has been applied to your account this time, but please ensure proper parking in the future.

Why is this important?
Incorrectly parked bikes can disrupt public spaces and violate our agreements with local authorities. We understand this can be frustrating, so we provide parking guidance at the end of each rental to help you avoid any issues.

Where to Park Correctly:
You can avoid fines by parking only at any public bike parking rack, located on public property within our operating zone, which is indicated in the app.
When bikes are parked incorrectly, our team may need to remove and re-park them, especially if public complaints arise or the bike remains unmoved for a certain period.

If You Have Any Questions:
If you have any questions about our parking policy, simply reply to this message, and we'll be happy to help.

Thank you for your understanding and cooperation.

Best regards,
The ${brandName} Team
`;

export const usePaymentEmailStr = () => {
  const whiteLabelCode = useWhiteLabelCode();
  const brandName = getWhiteLabelDisplayName(whiteLabelCode);

  return generateFineText(brandName);
};

export const useWarningEmailStr = () => {
  const whiteLabelCode = useWhiteLabelCode();
  const brandName = getWhiteLabelDisplayName(whiteLabelCode);

  return generateWarningText(brandName);
};
